import { ValueOf } from '@/types/util';

export const shopStatus = {
  WAITING: '有効待ち',
  AVAILABLE: '有効',
  CLOSED: '終了',
} as const;

export type ShopStatusKey = keyof typeof shopStatus;
export type ShopStatusValue = ValueOf<typeof shopStatus>;

export const shopStatusKeys = Object.keys(shopStatus) as ShopStatusKey[];

/** v-select用items */
export const shopStatusItems = shopStatusKeys
  .map((key) => ({
    title: shopStatus[key],
    value: key,
  }));
